import { render, staticRenderFns } from "./CheckItem.vue?vue&type=template&id=3274fd72&scoped=true"
import script from "./CheckItem.vue?vue&type=script&lang=js"
export * from "./CheckItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274fd72",
  null
  
)

export default component.exports